module.exports = __webpack_public_path__ + "static/media/img4.753783af.jpg";